import styled from 'styled-components'
import { Breadcrumb as BreadcrumbUI } from '@navent-jobs/ui-kit/components/breadcrumb'

export const BreadcrumbContainer = styled.div`
  margin-bottom: 10px;
`

export const BreadcrumbComponent = styled(BreadcrumbUI)`
  padding: 0px;
  align-items: start;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    display: block;
  }
`
